<div class="check-list__item">
  <div class="check-list__item-icon">
    <app-icon [icon]="'check'" [width]="16"></app-icon>
  </div>
  <span>
    <ng-content></ng-content>
  </span>
</div>